// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mVDx","content":"styles_content__13HKV"};